// Mock Trust Scores Data
// Extracted from TrustScoreSystem.tsx

export interface TrustScoreActivity {
  type: 'positive' | 'negative' | 'neutral';
  description: string;
  impact: number;
  date: string;
}

export interface TrustScoreData {
  currentScore: number;
  tier: 'Seed' | 'Sprout' | 'Trusted' | 'Elite';
  platformFee: number;
  perks: string[];
  requirements: string[];
  nextTierScore: number;
  scoreBreakdown: {
    engagementQuality: number;
    followerGrowth: number;
    contentConsistency: number;
    disputeRecord: number;
    completionRates: number;
    clientOutcomes: number;
  };
  recentActivity: TrustScoreActivity[];
}

export const mockTrustScores: TrustScoreData = {
  currentScore: 647,
  tier: 'Trusted',
  platformFee: 10,
  perks: [
    'Subscriptions up to $50/month',
    'Pay-per-consult access',
    'Early beta tools',
    'Priority support'
  ],
  requirements: [
    'Maintain 500+ trust score',
    'Complete 50+ sessions',
    '4.5+ average rating',
    'No major disputes in 6 months'
  ],
  nextTierScore: 800,
  scoreBreakdown: {
    engagementQuality: 85,
    followerGrowth: 78,
    contentConsistency: 92,
    disputeRecord: 95,
    completionRates: 88,
    clientOutcomes: 82
  },
  recentActivity: [
    {
      type: 'positive',
      description: 'Client completed 30-day program successfully',
      impact: 15,
      date: '2025-01-19'
    },
    {
      type: 'positive',
      description: 'Received 5-star review from new client',
      impact: 8,
      date: '2025-01-18'
    },
    {
      type: 'neutral',
      description: 'Published weekly health tip post',
      impact: 2,
      date: '2025-01-17'
    },
    {
      type: 'negative',
      description: 'Client reported scheduling conflict',
      impact: -5,
      date: '2025-01-16'
    }
  ]
}; 